import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const api = new API(BASE_URL);
const downloadAPI = new API(BASE_URL, null, {
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  responseType: 'blob',
});

class MortgageServices {
  static registerApplication = data => api.post(urls.WORKFLOW.REGISTER_APPLICATION, data);

  static saveApplication = payload => api.post(urls.MORTGAGE.SAVE_APPLICATION, payload);

  static fetchMortagageApplication = id => api.get(urls.MORTGAGE.FETCH_APPLICATION_MORTGAGE, id);

  static fetchBankLists = id => api.get(urls.MORTGAGE.FETCH_BANK_DETAIL, id);

  static checkoutMortgageApplication = id => api.post(urls.MORTGAGE.CHECKOUT_MORTGAGE_APPLICATION + '/' + id);

  static getApplicationContractPDF = appId => downloadAPI.get(urls.MORTGAGE.MORTGAGE_CONTRACT_PDF, appId);

  static getApplicationTitleDeedPDF = appId => downloadAPI.get(urls.MORTGAGE.MORTGAGE_TITLE_DEED_PDF, appId);

  static ownerApproveMortgage = data => api.post(urls.MORTGAGE.OWNER_APPROVE_MORTGAGE, data);

  static bankerApproveMortgage = data => api.post(urls.MORTGAGE.BANKER_APPROVE_MORTGAGE, data);

  static getApplicationPDFApp = appId => downloadAPI.get(urls.MORTGAGE.MORTGAGE_APPLICATION_PDF, appId);

  static getPropertyDocuments = data => api.get(urls.MORTGAGE.MORTGAGE_PROPERTY_DOCUMENTS, null, data);

  /** --------------- MORTGAGE BANK MAKER --------------- */
  static fetchMortgageTypes = () => api.get(urls.MORTGAGE.FETCH_MORTGAGE_TYPES);

  static fetchBankSignatories = id => api.get(urls.MORTGAGE.FETCH_BANK_SIGNATORIES, id);

  static fetchValuationCompanies = () => api.get(urls.MORTGAGE.FETCH_VALUATORS_V2);

  static fetchValuators = id => api.get(urls.MORTGAGE.FETCH_VALUATORS_V2, id);

  static checkoutMortgageBankApplication = id =>
    api.post(`${urls.MORTGAGE.CHECKOUT_MORTGAGE_BANK_MAKER_APPLICATION}/${id}`);

  static fetchMortgageDetails = id => api.get(urls.MORTGAGE.FETCH_MORTGAGE_DETAILS, id);

  static fetchExistingActivePMAs = id =>
    api.get(`${urls.MORTGAGE.FETCH_EXSITING_ACTIVE_PMA.replace(':propertyId', id)}`);

  static downloadMortgageAgreement = id => downloadAPI.get(urls.MORTGAGE.DOWNLOAD_MORTGAGE_AGREEMENT_PDF, id);
}

export default MortgageServices;
